// extracted by mini-css-extract-plugin
export var columnList = "_fa-0";